module.exports = __webpack_public_path__ + "img/us.5947945e.svg";